import Bookmarks from './Bookmarks';

export default Bookmarks;
